import React, { Component } from 'react';
import TwoFactorAuthenticationForm from './components/TwoFactorAuthenticationForm/TwoFactorAuthenticationForm';
import PropTypes from 'prop-types';

export default class Index extends Component {
    render() {
        const {
            i18n,
            i18nPrefix,
            onSubmit,
            handleChange,
            error,
            buttonDisabled,
            username,
            classes
        } = this.props;

        return (
            <TwoFactorAuthenticationForm
                i18n={ i18n }
                i18nPrefix={ i18nPrefix }
                onSubmit={ onSubmit }
                handleChange={ handleChange }
                error={ error }
                buttonDisabled={ buttonDisabled }
                username={ username }
                classes={ classes }
            />
        );
    }
}

Index.propTypes = {
    classes: PropTypes.object
};

Index.defaultProps = {
    classes: {
        modal: '',
        twoFactorAuthenticationForm: '',
        form: ''
    }
};
